let targetDateTime;
let countdownInterval;

// Yahan apni target date aur time set karein
function setTargetDateTime() {
    // Format: 'YYYY-MM-DD HH:MM:SS' (24-hour format)
    const targetDateString = '2025-10-31 28:59:59'; // Yahan apni date/time likhen
    
    // New York timezone ke according parse karein
    const [datePart, timePart] = targetDateString.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    
    targetDateTime = new Date(year, month - 1, day, hours, minutes, seconds);
}

function getNewYorkTime() {
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
   
    const parts = formatter.formatToParts(new Date());
    const values = {};
    parts.forEach(part => {
        values[part.type] = part.value;
    });
   
    return new Date(values.year, values.month - 1, values.day, values.hour, values.minute, values.second);
}

function getNext24HourEndNY() {
    const nyTime = getNewYorkTime();
    const tomorrow = new Date(nyTime);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
}

function updateCurrentDateTime() {
    const nyTime = getNewYorkTime();
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
   
    const day = dayNames[nyTime.getDay()];
    const date = String(nyTime.getDate()).padStart(2, '0');
    const month = monthNames[nyTime.getMonth()];
    const year = nyTime.getFullYear();
    const hours = String(nyTime.getHours()).padStart(2, '0');
    const minutes = String(nyTime.getMinutes()).padStart(2, '0');
    const seconds = String(nyTime.getSeconds()).padStart(2, '0');
   
    const dateTimeStr = `${day}, ${month} ${date}, ${year} - ${hours}:${minutes}:${seconds}`;
    document.getElementById('currentDateTime').textContent = dateTimeStr;
}

function updateTimer() {
    const nyTime = getNewYorkTime();
    const nyTimeMs = nyTime.getTime();
    
    // Check karo ke target date current date se ziada hai ya nahi
    if (targetDateTime > nyTime) {
        // Agar target date future mein hai, to custom date countdown chalao
        const endTime = targetDateTime.getTime();
        const distance = endTime - nyTimeMs;
        
        if (distance < 0) {
            clearInterval(countdownInterval);
            document.getElementById('days').textContent = '00';
            document.getElementById('hours').textContent = '00';
            document.getElementById('minutes').textContent = '00';
            document.getElementById('seconds').textContent = '00';
            return;
        }
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        document.getElementById('days').textContent = String(days).padStart(2, '0');
        document.getElementById('hours').textContent = String(hours).padStart(2, '0');
        document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
        document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
    } else {
        // Agar target date past mein hai ya current date hai, to 24-hour countdown chalao (purana code)
        const endTime = getNext24HourEndNY().getTime();
        const distance = endTime - nyTimeMs;
        
        if (distance < 0) {
            updateTimer();
            return;
        }
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        document.getElementById('days').textContent = String(days).padStart(2, '0');
        document.getElementById('hours').textContent = String(hours).padStart(2, '0');
        document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
        document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
    }
}

// Initialize
setTargetDateTime();
updateCurrentDateTime();
updateTimer();

// Update every second
countdownInterval = setInterval(() => {
    updateCurrentDateTime();
    updateTimer();
}, 1000);


// ==========================================
// Mega Menu 6 - STYLE START
//===========================================
document.addEventListener('DOMContentLoaded', function() {
  const sliderWrappers = document.querySelectorAll('.mega-menu-slider-wrapper-6');
  
  sliderWrappers.forEach(function(wrapper) {
    const track = wrapper.querySelector('.mega-menu-slider-track-6');
    const leftArrow = wrapper.querySelector('.slider-arrow-left-6');
    const rightArrow = wrapper.querySelector('.slider-arrow-right-6');
    const slides = wrapper.querySelectorAll('.mega-menu-slide-6');
    
    if (!track || !leftArrow || !rightArrow || slides.length === 0) return;
    
    // Get settings from data attributes
    const slidesDesktop = parseInt(wrapper.dataset.slidesDesktop) || 5;
    const slidesTablet = parseInt(wrapper.dataset.slidesTablet) || 3;
    const slidesMobile = parseInt(wrapper.dataset.slidesMobile) || 2;
    
    let currentIndex = 0;
    let slidesToShow = getSlidesToShow();
    const totalSlides = slides.length;
    
    function getSlidesToShow() {
      if (window.innerWidth <= 480) return slidesMobile;
      if (window.innerWidth <= 768) return slidesTablet;
      return slidesDesktop;
    }
    
    function updateSlider() {
      const slideWidth = slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(track).gap) || 20;
      const offset = -(currentIndex * (slideWidth + gap));
      track.style.transform = `translateX(${offset}px)`;
      
      // Update button states
      leftArrow.disabled = currentIndex === 0;
      rightArrow.disabled = currentIndex >= totalSlides - slidesToShow;
      
      // Update button opacity
      if (currentIndex === 0) {
        leftArrow.style.opacity = '0.3';
      } else {
        leftArrow.style.opacity = '1';
      }
      
      if (currentIndex >= totalSlides - slidesToShow) {
        rightArrow.style.opacity = '0.3';
      } else {
        rightArrow.style.opacity = '1';
      }
    }
    
    leftArrow.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
    
    rightArrow.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex < totalSlides - slidesToShow) {
        currentIndex++;
        updateSlider();
      }
    });
    
    // Arrow hover effect
    const arrows = [leftArrow, rightArrow];
    arrows.forEach(function(arrow) {
      const hoverBg = arrow.dataset.hoverBg;
      const originalBg = arrow.style.backgroundColor;
      
      arrow.addEventListener('mouseenter', function() {
        if (!arrow.disabled) {
          arrow.style.backgroundColor = hoverBg;
          arrow.style.color = '#fff';
          arrow.style.borderColor = hoverBg;
        }
      });
      
      arrow.addEventListener('mouseleave', function() {
        arrow.style.backgroundColor = originalBg;
        arrow.style.color = '';
        arrow.style.borderColor = '';
      });
    });
    
    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        slidesToShow = getSlidesToShow();
        currentIndex = Math.min(currentIndex, Math.max(0, totalSlides - slidesToShow));
        updateSlider();
      }, 250);
    });
    
    // Touch/Swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    track.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0 && currentIndex < totalSlides - slidesToShow) {
          // Swipe left - next
          currentIndex++;
          updateSlider();
        } else if (diff < 0 && currentIndex > 0) {
          // Swipe right - previous
          currentIndex--;
          updateSlider();
        }
      }
    }
    
    // Initial state
    updateSlider();
  });
});


// ==========================================
// Mega Menu 6 - STYLE END
//===========================================


// ==========================================
// Collection page faq start
//===========================================
/* const items = document.querySelectorAll('.accordion button');
    function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');
    
    for (i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-expanded', 'false');
    }
    
    if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true');
    }
    }
    
items.forEach((item) => item.addEventListener('click', toggleAccordion)); */
// ==========================================
// Collection page faq end
//===========================================


// ==========================================
// REMOVE CART ITEM START
//===========================================
/*
// Main paircode removal functionality
document.addEventListener("click", function(event) {
    // const button = event.target.closest('.cart-remove[data-cart-remove]');
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    // Get variant ID from button
    const variantId = button.getAttribute('data-cart-remove-id');
    
    if (!variantId) {
       console.error('No variant ID found on button');
        return;
    }
    
    // console.log('🔄 Starting paircode removal for variant:', variantId);
    
    // Show loading state
    button.style.opacity = '0.5';
    button.innerHTML = 'Removing...';
    button.disabled = true;
    
    fetch('/cart.js')
    .then(response => {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
    })
    .then(cart => {
      console.log('📦 Current cart items:', cart.items.length);
        
        // Step 1: Find the clicked item by variant_id
        let clickedItem = null;
        cart.items.forEach((item, index) => {
            if (item.variant_id.toString() === variantId.toString()) {
                clickedItem = item;
                // console.log(`✅ Found clicked item at index ${index}:`, item.title);
            }
        });
        
        if (!clickedItem) {
            throw new Error('Clicked item not found in cart');
        }
        
        // Step 2: Get paircode from clicked item
        const clickedPaircode = clickedItem.properties?.paircode;
        console.log('🔍 Clicked item paircode:', clickedPaircode);
        
        if (!clickedPaircode) {
            // console.log('⚠️ No paircode found, removing only clicked item');
            // Remove only this item if no paircode
            const updates = {};
            updates[clickedItem.key] = 0;
            return removeItems(updates);
        }
        
        // Step 3: Find ALL items with same paircode
        const updates = {};
        let matchingItemsCount = 0;
        
        cart.items.forEach((item, index) => {
            const itemPaircode = item.properties?.paircode;
            
            // Check if this item has same paircode
            if (itemPaircode && itemPaircode.toString() === clickedPaircode.toString()) {
                updates[item.key] = 0; // Set quantity to 0 to remove
                matchingItemsCount++;
                console.log(`🎯 Matched item ${matchingItemsCount}:`, {
                    title: item.title,
                    variant_id: item.variant_id,
                    paircode: itemPaircode,
                    key: item.key
                });
            }
        });
        
        // console.log(`📝 Total items to remove: ${matchingItemsCount}`);
        // console.log('🗑️ Updates object:', updates);
        
        if (matchingItemsCount === 0) {
            throw new Error('No items found with matching paircode');
        }
        
        // Step 4: Remove all matching items
        return removeItems(updates);
    })
    .catch(error => {
        console.error('❌ Error:', error.message);
        alert('Error removing items: ' + error.message);
        
        // Reset button state
        button.style.opacity = '1';
        button.innerHTML = '×'; // Or original button content
        button.disabled = false;
    });
    
    // Helper function to remove items
    function removeItems(updates) {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates: updates })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to update cart');
            }
            return response.json();
        })
        .then(updatedCart => {
            console.log('✅ Cart updated successfully');
            console.log('🔄 Reloading page...');
            window.location.reload();
        });
    }
});

// Debug function to check current cart
function checkCartPaircodes() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        console.log('\n=== CART PAIRCODE ANALYSIS ===');
        console.log('Total items in cart:', cart.items.length);
        
        const paircodeGroups = {};
        
        cart.items.forEach((item, index) => {
            const paircode = item.properties?.paircode;
            console.log(`\nItem ${index + 1}:`);
            console.log('  Title:', item.title);
            console.log('  Variant ID:', item.variant_id);
            console.log('  Key:', item.key);
            console.log('  Paircode:', paircode || 'None');
            
            if (paircode) {
                if (!paircodeGroups[paircode]) {
                    paircodeGroups[paircode] = [];
                }
                paircodeGroups[paircode].push({
                    title: item.title,
                    variant_id: item.variant_id
                });
            }
        });
        
        // console.log('\n=== PAIRCODE GROUPS ===');
        Object.keys(paircodeGroups).forEach(paircode => {
            console.log(`\nPaircode ${paircode}:`);
            paircodeGroups[paircode].forEach((item, idx) => {
                 console.log(`  ${idx + 1}. ${item.title} (ID: ${item.variant_id})`);
            });
        });
        
        return paircodeGroups;
    })
    .catch(console.error);
}

// Initialize
console.log('🚀 Paircode removal system initialized');
console.log('💡 Run checkCartPaircodes() to see current paircode groups');

// Auto-check on load (remove in production)
setTimeout(checkCartPaircodes, 500);
*/
// ==========================================
// REMOVE CART ITEM END
//===========================================



//===========================================
// Slick Slider Personolize product
// ==========================================
 (function($){
    $(document).ready(function(){
        $('div.product-gallery .product-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.slider-nav',
            prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0647/9141/2970/files/arrow_back.png?v=1742318719"></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0647/9141/2970/files/arrow_forward.png?v=1742318719"></button>'
        });
        $('div.product-gallery .slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-slider',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            responsive: [
                {
                breakpoint: 699,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
                },
                {
                breakpoint: 484,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
                }
            ]
        });
    });
    
    $(document).ready(function() {
        $('.decrease').on('click', function() {
            var $input = $('.quantity-input');
            var value = parseInt($input.val());
            var min = parseInt($input.attr('min'));
            if (value > min) {
                $input.val(value - 1);
            }
        });

        $('.increase').on('click', function() {
            var $input = $('.quantity-input');
            var value = parseInt($input.val());
            $input.val(value + 1);
        });
    });
})(jQuery);


